module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-263.87f01808.svg";